import { IScriptTableBehavior, ITableScriptExecuteBehavior, ScriptExecuteTimingKinds } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanTableScriptExecutable } from "../../../beans/objects";
import { IntegerTranslator, StringTranslator } from "../../values";
import { ScriptExecuteBehaviorTranslator } from "./ScriptExecuteBehaviorTranslator";

export class ScriptTableBehaviorTranslator {
  from(bean: IObjectBeanTableScriptExecutable): IScriptTableBehavior {
    const index = {
      row: this.integer.from(bean["@row"]),
      column: this.integer.from(bean["@column"]),
    };
    const isBase = (index.row === 0) && (index.column === 0);
    return {
      index,
      size: isBase
        // sizeは同じscriptを探さないと分からないので後で更新要.一旦1x1で初期化.
        ? {
          row: 1,
          column: 1,
        }
        : undefined,
      scriptExecuteBehavior: isBase
        ? this.scriptTable.from(bean)
        : undefined,
    };
  }

  to(object: IScriptTableBehavior) {
    const results = ((object.index.row === 0) && (object.index.column === 0))
      ? this.scriptTable.to(object.scriptExecuteBehavior)
      : {};
    // sizeはそもそもobjectのbeanには含まれないので特に出力しない.
    results.row = this.integer.to(object.index.row);
    results.column = this.integer.to(object.index.column);
    return results;
  }

  private readonly scriptTable = {
    from: (bean: IObjectBeanTableScriptExecutable): ITableScriptExecuteBehavior => {
      const behavior = this.script.from(bean) as ITableScriptExecuteBehavior;
      // 外部データの場合はupdate属性の解釈が違うので上書きする.
      behavior.timing = (bean["@update"] === "1")
        ? ScriptExecuteTimingKinds.DocumentEditBegun
        : ScriptExecuteTimingKinds.Clicked;
      behavior.inputValuesCsvFilePathFormat = this.string.from(bean["@input-value-path"]);
      return behavior;
    },
    to: (object: ITableScriptExecuteBehavior) => {
      const script = this.script.to(object) as any;
      // 外部データの場合はupdate属性の解釈が違うので上書きする.
      script.update = (object.timing === ScriptExecuteTimingKinds.DocumentEditBegun)
        ? "1"
        : "0";
      script.inputValuePath = this.string.to(object.inputValuesCsvFilePathFormat);
      return script;
    }
  };

  private readonly script = new ScriptExecuteBehaviorTranslator();
  private readonly string = new StringTranslator();
  private readonly integer = new IntegerTranslator();
}
